<template>
  <div
    class="d-flex"
    :style="$route.path == '/index' ? '' : 'background-color: #fff;'"
  >
    <div>
      <img :src="$route.path == '/index' ? src : srcImages" />
    </div>
    <div class="title_Tabs">
      <div class="d-flex">
        <div v-for="item in tabList" class="set-tabs-style" :class="`${$route.path == '/index' ? 'color-tab-one' : 'color-tab-two'}`">
          <el-dropdown v-if="item.childList" @command="handleCommand" placement="bottom">
            <div
              :class="`set-tabs-item ${isMenuActive(item) ? 'is-active' : ''} ${$route.path == '/index' ? 'color-tab-one' : 'color-tab-two'}`"
              style="fontSize: 16px;">
              {{item.name}}
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="childItem in item.childList"
                :key="childItem.key"
                :command="childItem.path"
              >
                <router-link
                  class="set-tabs-item"
                  :class="`${isChildActive(childItem) ? 'dropdown-is-active' : ''}`"
                  :to="childItem.path"
                >{{childItem.name}}</router-link>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <router-link
            v-else
            :to="item.path"
            :class="`set-tabs-item ${isMenuActive(item) ? 'is-active' : ''} ${$route.path == '/index' ? 'color-tab-one' : 'color-tab-two'}`">
            {{item.name}}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logo from "@/assets/Image/logo001.png";
import { recordBySlug } from "@/utils/casePath";
export default {
  data() {
    return {
      src: logo,
      srcImages: "https://f.kzspp.com/cms/new/theme/kz/images/logo002.png",
      businessList: [ //业务领域下拉路由路径
        "/receivables", // 应收款
        "/marriage", //婚姻家事
        "/criminal", //刑事辩护
        "/debtRestructuring", //债务重组
        "/propertyLegalServices", //物业法律顾问
      ],
      // tabValue: "tab1",
      tabList: [
        {
          name: "首页",
          key: "tab1",
          path: "/index",
        },
        {
          name: "关于旷真",
          key: "tab2",
          path: "/about",
        },
        {
          name: "业务领域",
          key: "tab9",
          path: "/receivables",
          childList: [
            {
              name: "应收款",
              key: "tab9-1",
              path: "/receivables",
            },
            {
              name: "婚姻家事",
              key: "tab9-2",
              path: "/marriage",
            },
            {
              name: "刑事辩护",
              key: "tab9-3",
              path: "/criminal",
            },
            {
              name: "债务重组",
              key: "tab9-4",
              path: "/debtRestructuring",
            },
            {
              name: "物业法律顾问",
              key: "tab9-5",
              path: "/propertyLegalServices",
            }
          ]
        },
        {
          name: "旷真案例",
          key: "tab10",
          path: "/cases/family",
          childList: [
            {
              name: "家事案例",
              key: "tab10-1",
              path: "/cases/family",
            },
            {
              name: "刑事案例",
              key: "tab10-2",
              path: "/cases/criminal",
            },
            {
              name: "应收款案例",
              key: "tab10-3",
              path: "/cases/receivables",
            },
          ],
        },
        {
          name: "新闻动态",
          key: "tab6",
          path: "/news",
        },
        {
          name: "加入旷真",
          key: "tab7",
          path: "/joinUs",
        },
        {
          name: "联系我们",
          key: "tab8",
          path: "/contactUs",
        }
      ]
    };
  },
  mounted() {},
  methods: {
    toOtherPage(item) {
      if (item.key != "tab9") {
        if (item.path == this.$route.path) {
          window.location.reload();
        } else {
          this.$router.push(item.path);
        }
      }
    },
    isMenuActive(item) {
      if (item.name == "业务领域") {
        return this.businessList.includes(this.$route.path);
      }
      if (item.name == "旷真案例") {
        const path = this.$route.path || "";
        return path.indexOf("/cases") === 0 || path.indexOf("/case/") === 0;
      }
      if (item.childList) {
        return item.childList.some((child) => child.path == this.$route.path);
      }
      return this.$route.path == item.path;
    },
    isChildActive(child) {
      const path = this.$route.path || "";
      if (path.indexOf("/case/") === 0) {
        const rec = recordBySlug(path.replace(/^\/case\//, "").split("/")[0]);
        if (!rec) return false;
        return child.path === `/cases/${rec.type}`;
      }
      if (String(child.path || "").indexOf("/cases/") === 0) {
        return path === child.path || path.indexOf(child.path + "/") === 0;
      }
      return path === child.path;
    },
    handleCommand(value) {
      if (value == this.$route.path) {
        window.location.reload();
      } else {
        this.$router.push(value);
      }
    }
  }
};
</script>

<style scoped>
.d-flex {
  display: flex;
}
.title_Tabs {
  padding-left: 110px;
  letter-spacing: 2px;
  font-size: 16px;
}
.title_Tabs >>> .el-tabs__nav-wrap::after {
  position: static !important;
}
.title_Tabs,
.el-tabs,
.title_Tabs >>> .el-tabs__header,
.title_Tabs >>> .is-top {
  height: 48px;
}
.color-tab-one {
  color: #fff;
}
.el-dropdown-menu >>> .set-tabs-item {
  color: #000;
}
.el-dropdown-menu >>> .set-tabs-item:hover {
  color: #f44336;
}
.el-dropdown-menu >>> .dropdown-is-active {
  color: #f44336;
}
.color-tab-two {
  color: #000;
}
.title_Tabs >>> .el-tabs__item {
  font-size: 16px;
  line-height: 58px;
}
.title_Tabs >>> .is-active {
  position: relative;
  color: #f44336;
}
.title_Tabs >>> a {
  padding-bottom: 10px;
}
.title_Tabs >>> .is-active::after {
  position: absolute;
  bottom: -1px;
  left: 50%;
  transform: translateX(-50%);
  height: 3px;
  width: 100%;
  background-color: #f44336;
  content: "";
  z-index: 999999;
}
.title_Tabs >>> .el-tabs__item:nth-child(2).is-active::after {
  /* width: ; */
  left: 25%;
}
.title_Tabs >>> .el-tabs__active-bar.is-top {
  background: none !important;
}
.title_Tabs >>> .set-tabs-item:hover {
  color: #f44336;
  cursor: pointer;
}
.set-tabs-style {
  margin-top: 12px;
  margin-right: 28px;
  line-height: 36px;
  font-size: 16px;
  cursor: pointer;
}
.set-tabs-item {
  text-decoration: none;
}
.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #fbe8e6;
  color: #f44336;
}
.dropdown-is-active {
  color: #f44336;
}
</style>
